module.exports = __webpack_public_path__ + "static/img/pop_bg.57e69e5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/statistic/pop_bg.png
// module id = z2Ig
// module chunks = 2